import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Roseville, MN?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a Roseville area post office can take 2–6 months — not suitable for time-sensitive travel.",
  },
  {
    q: "What options do Roseville families have for expedited passports?",
    a: "Roseville families can use our 2–9 business day expedited processing for vacations, 24-hour emergency processing for urgent situations, or 3–5 week standard expedited service. We guide you to the right option based on your departure date.",
  },
  {
    q: "I work in healthcare or professional services in the St. Paul area — how fast can you process my business passport?",
    a: "Healthcare and professional services professionals in Roseville and the north metro are common clients. We process business renewals as fast as 2–9 business days. Emergency processing can be as fast as 24 hours.",
  },
  {
    q: "Can Roseville residents with international family get heritage travel passports quickly?",
    a: "Absolutely. Many Roseville residents from Southeast Asian and other communities need passports for family visits on short notice. We process heritage travel passports with the same speed and care as any other application.",
  },
  {
    q: "Do I need to visit a Fast Passport Center office in Roseville?",
    a: "No — start online and ship your documents overnight. There is no local Fast Passport Center office in Roseville. You can ship from any UPS, FedEx, or shipping location near Rosedale Center.",
  },
  {
    q: "What is the nearest passport acceptance facility to Roseville?",
    a: "The Roseville Post Office accepts passport applications. St. Paul facilities are also nearby. First-time applicants and minors must visit an acceptance clerk in person. We guide you through this step.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
  },
  {
    q: "Can St. Paul and Little Canada residents use the same expedited service?",
    a: "Yes. St. Paul, Little Canada, Shoreview, and Maplewood travelers have the same access to our expedited services as Roseville residents. Since we operate remotely, your physical location in Ramsey County does not affect processing speed. Ship your documents overnight from any UPS or FedEx location, and we handle the rest.",
  },
];

export default function RosevilleFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Roseville and north metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}